import React from 'react';
import styled from 'styled-components';
import { Color } from 'core';
import { faEdit, faMagic, faCopy } from '@fortawesome/free-solid-svg-icons';
import { ContentTypeCard } from './ContentTypeCard';
import { CardGrid } from './FormComponents';

interface CourseCreateTypeSelectorProps {
  onManualCreateClick: () => void;
  onSmartCreateClick: () => void;
  onFromExistingClick: () => void;
}

export const CourseCreateTypeSelector = ({
  onManualCreateClick,
  onSmartCreateClick,
  onFromExistingClick,
}: CourseCreateTypeSelectorProps) => {
  return (
    <>
      <SectionTitle>How would you like to create this?</SectionTitle>
      <CardGrid>
        <ContentTypeCard
          title="Manual Create"
          description="Build your course from scratch with full control over every detail."
          icon={faEdit}
          iconColor={Color.iconBlue}
          onClick={onManualCreateClick}
        />
        <ContentTypeCard
          title="Smart Create"
          description="Let AI help you generate course content quickly and efficiently."
          icon={faMagic}
          iconColor={Color.iconPurple}
          onClick={onSmartCreateClick}
        />
        <ContentTypeCard
          title="From Existing Course"
          description="Copy structure and content from a course you've already built."
          icon={faCopy}
          iconColor={Color.iconGreen}
          onClick={onFromExistingClick}
        />
      </CardGrid>
    </>
  );
};

const SectionTitle = styled.h3`
  text-align: center;
  color: ${Color.darkGray};
  margin: 0 0 40px 0;
  font-weight: 400;
  font-size: 20px;
`;
